<div class="container mt-4 mb-5">
  <div class="row">
    <div class="col-6">
      <h4 i18n>Carrinho</h4>
    </div>
    <div *ngIf="SITE.carrinhoCodigoBarras" class="col-6 text-right">
      <div class="btn-group btn-group-toggle" data-toggle="buttons">
        <label (click)="toRoute(1)" [class.active]="modo == 1" class="btn btn-primary">
          <input type="radio" name="options" id="option1" autocomplete="off" /><i class="icofont-list"></i>
        </label>
        <label (click)="toRoute(2)" [class.active]="modo == 2" class="btn btn-primary">
          <input type="radio" name="options" id="option3" autocomplete="off" /><i class="icofont-barcode"></i>
        </label>
      </div>
    </div>
  </div>

  <div *ngIf="modo == 2" class="row modo2">
    <div *ngIf="!pedido" class="col-lg-6 offset-lg-3 text-center">
      <h5 i18n>Selecione um Pedido!</h5>
      <img src="assets/empty-cart.png" class="img-fluid" />
    </div>
    <div *ngIf="pedido" class="col-6 pl-1 pr-1 pt-2">
      <!--<button *ngIf="tipoUsuario=='GESTOR'" (click)="test01();">teste 200 barras 1/2 segundo</button>-->
      <button routerLink="/checkout" class="btn btn-sm btn-primary" i18n>
        <i class="icofont-check-circled"></i> Finalizar pedido
      </button>
      <div class="row mt-2 mb-2">
        <div class="col-sm-12 pl-0 pr-0">
          <label>{{ SITE.labelCliente }}</label><br />
          <div *ngFor="let pc of pedido.clientes">
            <span>{{ pc.cliente[SITE.identificacaoCliente] }} -
              {{ pc.cliente.nome }}</span>
          </div>
        </div>
        <div class="col-4 pl-0">
          <label i18n>Código</label><br />
          <span>{{ pedido.id }}</span>
        </div>
        <div class="col-4 pl-0">
          <label i18n>Itens</label><br />
          <span>{{ pedido.quantidade }}</span>
        </div>
        <div class="col-4 pr-0">
          <label i18n>Valor Total</label><br />
          <span class="money2" i18n>R$ {{ pedido.total | currency : "BRL" : "" }}</span>
        </div>
      </div>
      <form (ngSubmit)="onSubmit()" [formGroup]="form" class="mb-4">
        <div class="input-group shadow-sm">
          <input id="codigoBarras" formControlName="codigoBarras" type="text"
            class="form-control border-1 rounded-start" placeholder="Digite o código de barras"
            style="font-size: 1.2rem" autocomplete="off" />
          <button class="btn btn-primary buttonRight px-4" type="submit" style="font-size: 1rem">
            Ir
          </button>
        </div>
      </form>

      <div class="table-responsive mt-4">
        <table class="table align-middle">
          <tbody *ngFor="let i of pedido.itens">
            <tr>
              <td colspan="5" class="text-muted small pb-2">
                <b>{{ i.codigoBarras }}</b>
              </td>
            </tr>
            <tr>
              <td style="width: 60px">
                <img *ngIf="i.imagem; else elseBlockImg" [src]="API_IMAGENS_PRODUTOS + i.imagem"
                  class="img-fluid rounded shadow-sm" style="max-width: 50px" />
                <ng-template #elseBlockImg>
                  <img src="assets/no-product-image.jpg" class="img-fluid rounded shadow-sm" style="max-width: 50px" />
                </ng-template>
              </td>
              <td class="text-truncate">
                {{ i.produtoDescricao | slice : 0 : 50 }}
              </td>
              <td class="text-muted">
                {{ i.quantidade }}x
              </td>
              <td class="fw-semibold text-primary">
                R$ {{ i.total | currency : "BRL" : "" }}
              </td>
              <td class="text-center">
                <button (click)="confirmDelModo2(i.id)" data-toggle="modal" data-target="#confirmDelModalModo2"
                  class="btn btn-light border-0 text-danger" title="Excluir">
                  <i class="icofont-trash"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>
  </div>
  <div *ngIf="modo == 1" class="row">
    <div *ngIf="!pedido" class="col-lg-6 offset-lg-3 text-center">
      <h5 i18n>Selecione um Pedido!</h5>
      <img src="assets/empty-cart.png" class="img-fluid" />
    </div>
    <div *ngIf="pedido" class="col-lg-12">
      <div class="row mt-2 mb-2">
        <div class="col-sm-1">
          <label i18n>Código</label><br />
          {{ pedido.id }}
        </div>
        <div class="col-sm-5">
          <label><input type="checkbox" value="true" [(ngModel)]="pedidoClienteSelected.todos"
              (change)="changePedidoClienteSelectedTodos()" />
            {{ SITE.labelCliente }}</label><br />
          <div *ngFor="let pc of pedido.clientes">
            <label style="font-size: inherit">
              <input type="checkbox" value="true" [(ngModel)]="pedidoClienteSelected[pc.cliente.id]"
                (change)="changePedidoClienteSelected()" />
              {{ pc.cliente[SITE.identificacaoCliente] }} -
              {{ pc.cliente.nome }}
            </label>
          </div>
        </div>
        <div class="col-sm-3">
          <label>{{ SITE.labelFilial }}</label><br />
          {{ pedido.filial.codigo }} - {{ pedido.filial.descricao }}
        </div>
        <div class="col-sm-3">
          <label i18n>Tabela</label><br />
          {{ pedido.tabela.codigo }} - {{ pedido.tabela.descricao }}
        </div>
      </div>
      <div class="row mt-2 mb-2">
        <div class="col-sm-1"></div>
        <div class="col-sm-5">

        </div>
        <div class="col-sm-3">
          <label>{{ SITE.labelPedidoTipo }}</label><br />
          {{ pedido.tipo.tipo }} - {{ pedido.tipo.descricao }}
        </div>
        <div class="col-sm-3 importa-planilha-itens">
          <div class="mb-3" *ngIf="!loadingUpload">
            <label for="formFile" class="form-label" i18n>Importar planilha de itens</label>
            <br />
            <input class="input-file" type="file" id="formFile" accept=".xls, .xlsx"
              (change)="onFileSelected($event)" />
          </div>
          <div class="mb-3 loading-circle-container" *ngIf="loadingUpload">
            <div class="loading-circle"></div>
          </div>
        </div>
      </div>
      <div class="row mt-2 mb-2">
        <div class="col-4">
          <label i18n>Filtro de itens</label>
          <input type="text" class="form-control" i18n-placeholder="Search" placeholder="Digite um item"
            [(ngModel)]="term" (input)="filterItem()">
        </div>
      </div>
      <div *ngIf="!pedido.itens.length" class="col-lg-6 offset-lg-3 text-center">
        <img src="assets/empty-cart.png" style="height: 230px" class="img-fluid" />
        <h4 i18n>Carrinho vazio!</h4>
      </div>
      <div *ngIf="pedidoItens.length">
        <div class="table-responsive">
          <table class="table table-hover table-condensed table-striped table-sm table-responsive-xs">
            <thead class="table-head">
              <tr>
                <th>
                  <input type="checkbox" class="form-control checkbox-item"
                    (change)="toggleSelectAll($event.target.checked)">
                </th>
                <th></th>
                <th><label i18n>Produto</label></th>
                <th><label i18n>Quant.</label></th>
                <th class="unt-preco"><label i18n>R$ Preço unt.</label></th>
                <th><label i18n>R$ Preço</label></th>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of pedidoItensFiltrado">
                <td>
                  <input type="checkbox"
                  class="form-control checkbox-item"
                  [checked]="isSelected(item.produto)"
                  (change)="toggleSelection($event, item)">
           
                </td>
                <td>
                  <a href="javascript:void(0);" routerLink="/produto/{{ item.produto }}"
                    i18n-routerLink="/product/{{ item.produto }}">
                    <img *ngIf="item.imagemProduto; else elseBlockImg"
                      src="{{ API_IMAGENS_PRODUTOS }}{{ item.imagemProduto }}" class="img-fluid"
                      style="max-width: 50px" />
                    <ng-template #elseBlockImg><img src="assets/no-product-image.jpg" class="img-fluid"
                        style="max-width: 50px" /></ng-template>
                  </a>
                </td>
                <td>
                  {{ item.produtoReferencia }} - {{ item.produtoDescricao }}
                </td>
                <td>{{ item.quantidade }}</td>
                <td class="unt-preco" i18n>
                  R$
                  {{
                  (this.SITE.mostraImpostoDetalhado
                  ? item.total/item.quantidade
                  : (item.total + item.quantidade * item.imposto)/item.quantidade
                  ) | currency : "BRL" : ""
                  }}
                </td>
                <td i18n>
                  R$
                  {{
                  (this.SITE.mostraImpostoDetalhado
                  ? item.total
                  : item.total + item.quantidade * item.imposto
                  ) | currency : "BRL" : ""
                  }}
                </td>
                <td class="text-center align-middle">
                  <button routerLink="/produto/{{ item.produto }}" i18n-routerLink="/product/{{ item.produto }}"
                    *ngIf="!pedido.salvoCheckout" title="Editar" class="btn btn-outline-primary">
                    <i class="icofont-ui-edit"></i>
                  </button>
                </td>
                <td class="text-center align-middle">
                  <button (click)="confirmDel(item)" *ngIf="!pedido.salvoCheckout" data-toggle="modal"
                    data-target="#confirmDelModal" title="Excluir" class="btn btn-outline-primary">
                    <i class="icofont-trash"></i>
                  </button>
                </td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td>
                  <b>{{ pedidoItensQuantSum }}</b>
                </td>
                <td></td>
                <td>
                  <b i18n>R$
                    {{
                    this.SITE.mostraImpostoDetalhado
                    ? (pedido.subtotal | currency : "BRL" : "")
                    : (pedidoItensPrecoSumComImp | currency : "BRL" : "")
                    }}</b>
                </td>
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="row">
          <!-- <div class="col-lg-6 mt-3 mb-3 importar-planilha-itens">
            <div class="mb-3">
              <label for="formFile" class="form-label">Importar planilha de itens</label>
              <br/>
              <input 
                class="input-file" 
                type="file" 
                id="formFile" 
                accept=".xls, .xlsx" 
              />
            </div>
          </div> -->
          <div class="col-lg-6 mt-3 mb-3">
            <div class="row mb-1">
              <div class="col-8 text-right" *ngIf="this.SITE.mostraImpostoDetalhado">
                Subtotal:
              </div>
              <div class="col-4">
                <span *ngIf="this.SITE.mostraImpostoDetalhado" i18n>R$ {{ pedido.subtotal | currency : "BRL" : ""
                  }}</span>
              </div>
            </div>
            <div *ngIf="pedido.impostos && this.SITE.mostraImpostoDetalhado" class="row mb-1">
              <div class="col-8 text-right" i18n>+ Impostos:</div>
              <div class="col-4">
                <span style="color: red" i18n>R$ {{ pedido.impostos | currency : "BRL" : "" }}</span>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-8 text-right">
                <span style="font-size: 1rem; font-weight: bold" i18n>Valor total:</span>
              </div>
              <div class="col-4">
                <span class="money2" i18n>R$ {{ pedido.total | currency : "BRL" : "" }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-2">
          <button i18n-routerLink="/catalog" routerLink="/catalogo" class="btn btn-lg btn-primary float-left" i18n>
            Continuar comprando
          </button>
          <button *ngIf="selectedIds.length === 0" routerLink="/checkout" class="btn btn-lg btn-primary float-right"
            i18n>
            <i class="icofont-check-circled"></i> Finalizar pedido
          </button>
          <button (click)="excluiItems($event)" type="button" *ngIf="selectedIds.length > 0"
            class="btn btn-lg btn-primary float-right" i18n>
            Excluir itens
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal fade" id="confirmDelModalModo2" tabindex="-1" role="dialog" aria-labelledby="confirmDelModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" i18n>Confirma exclusão?</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-footer">
        <button (click)="removeItemModo2()" type="button" data-dismiss="modal" class="btn btn-outline-primary">
          Ok
        </button>
        <button type="button" data-dismiss="modal" class="btn btn-primary" i18n>
          Cancelar
        </button>
      </div>
    </div>
  </div>
</div>
<div class="modal fade" id="confirmDelModal" tabindex="-1" role="dialog" aria-labelledby="confirmDelModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" i18n>Deseja realmente excluir?</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-footer">
        <button (click)="removeItem()" type="button" data-dismiss="modal" class="btn btn-outline-primary">
          Ok
        </button>
        <button type="button" data-dismiss="modal" class="btn btn-primary" i18n>
          Cancelar
        </button>
      </div>
    </div>
  </div>
</div>